import React, { useState, useEffect } from "react";
import {
  Grid,
  Button,
  Typography,
  IconButton,
  makeStyles,
} from "@material-ui/core";
import { DataGrid, GridColDef } from "@mui/x-data-grid";
import Box from "@mui/material/Box";
import CloseIcon from "@mui/icons-material/Close";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";
import update from "immutability-helper";
var findAnd = require("find-and");
const useStyles = makeStyles((theme) => ({ 
  buttonStyle: {
    borderRadius: 4,
    width: "150px",
    padding: 0,
    color: "#fff",
    height: "34px",
    backgroundColor: "#0D47A1",
    textTransform: "none",
    "&:active": {
      backgroundColor: "#0D47A1",
    },
    "&:hover": {
      backgroundColor: "#1E88E5",
    },
  },
  dataGridStyle: {
    width: "100%",
    "& .super-app-theme--header": {
      backgroundColor: "#99D4FF",
      color: "#0D47A1",
      fontSize: 18,
      // fontWeight: 700,
    }, 
    "& .MuiDataGrid-cell": {
      fontSize: 16,
      fontWeight: 400,
      display:"flex", 
      flexDirection:"row", 
      justifyContent:"start",
      minHeight: 50,
    },
    "& .MuiDataGrid-columnHeader .MuiDataGrid-columnSeparator": {
      display: "none",
    },
    "& .MuiDataGrid-row": {
      backgroundColor: "#E3F2FD !important",
    },
    "& .MuiDataGrid-cell[data-field='question']": {
      backgroundColor: "#EFFFCA",
    },    
    "&.MuiDataGrid-root .MuiDataGrid-columnHeader:focus, &.MuiDataGrid-root .MuiDataGrid-cell:focus": {
      outline: "none !important",
    },
    "&.MuiDataGrid-cell:focus-within": {
      outline: " none !important",
    },
  },
}));

export default function CompareTextAreaDialog({
  appName1,
  appName2,
  question,
  fullAnswer1,
  fullAnswer2,
  closeDialog,
}) {
  const classes = useStyles();
  const [open, setOpen] = useState(true);

  const handleClose = () => {
    setOpen(false);
    closeDialog && closeDialog();
  }; 

  const columns: GridColDef[] = [
    {
      field: "answer1",
      headerClassName: "super-app-theme--header",
      width: 400,
      minHeight: 50,
      flex: 2,
      align: "left",
      headerAlign: "center",
      sortable: false,
      disableColumnMenu: true,
      renderHeader: (params: GridColumnHeaderParams) => (
        <span>
          Applicant Name: <strong>{appName1}</strong>
        </span>       
      ),
      renderCell: (rows) => {        
        if (rows.row.answer1)
          return <div style={{ padding: 10 }}>{rows.row.answer1}</div>;
      }
    },
    {
      field: "question",
      headerClassName: "super-app-theme--header",
      width: 400,
      minHeight: 50,
      flex: 2,
      align: "left",
      headerAlign: "center",
      sortable: false,
      disableColumnMenu: true,
      renderHeader: (params: GridColumnHeaderParams) => (
        <span>
          <strong>Question</strong>
        </span>       
      ),
      renderCell: (rows) => {        
        if (rows.row.question){
          return (            
            <Typography 
              style={{
                wordBreak: "break-word",
              }}
            >
              {rows.row.question}
            </Typography>
          )
        }
      },
    },
    {
      field: "answer2",
      headerClassName: "super-app-theme--header",
      width: 400,
      minHeight: 50,
      flex: 2,
      align: "left",
      headerAlign: "center",
      sortable: false,
      disableColumnMenu: true,
      renderHeader: (params: GridColumnHeaderParams) => (
        <span>
          Applicant Name: <strong>{appName2}</strong>
        </span>      
      ),
      renderCell: (rows) => {        
        if (rows.row.answer2)
          return <div style={{ padding: 10 }}>{rows.row.answer2}</div>;
      }
    }, 
  ];

  let rows = [];
  
  rows.push({
    index: 0,
    answer1: fullAnswer1,
    question: question,
    answer2: fullAnswer2,    
  })

  return (
    <div style={{ width: "100%", minWidth: 1000 }}>
      <Dialog
        open={open}
        onClose={handleClose}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
        sx={{
          "& .MuiDialog-container": {
            "& .MuiPaper-root": {
              minWidth: "1000px",
            },
          },
        }}
      >
        <DialogTitle
          sx={{ m: 0, p: 2 }}
          id="alert-dialog-title"
          style={{ display: "flex", justifyContent: "space-between" }}
        >
          <Grid
            container
            style={{
              display: "flex",
              flexDirection: "row",
              alignItems: "center",
            }}
          >
            <Grid
              item
              xs={11}
              style={{
                textAlign: "center",
                paddingLeft: 15,
              }}
            >
              Full Content
            </Grid>
            <Grid item xs={1}>
              <IconButton
                aria-label="close"
                onClick={handleClose}
                sx={{
                  position: "absolute",
                  right: 8,
                  top: 8,
                  align: "right",
                  color: (theme) => theme.palette.grey[500],
                }}
              >
                <CloseIcon />
              </IconButton>
            </Grid>
          </Grid>
        </DialogTitle>

        <DialogContent style={{ overflow: "hidden" }}>
          <DialogContentText id="alert-dialog-description">
            <Box style={{ height: 500 }}>
              <DataGrid
                className={classes.dataGridStyle}
                columns={columns}
                rows={rows}
                showCellRightBorder={true}
                autoWidth={true}
                getRowId={(row) => row.index}              
                getCellClassName={(rows) => {
                  if (rows.row.index === 0) return "colSpan";
                }}
                getRowHeight={() => "auto"}
                hideFooterPagination
                hideFooterSelectedRowCount
                hideFooter
              /> 
            </Box>           
          </DialogContentText>
        </DialogContent>
        <DialogActions style={{ justifyContent: "center" }}>
          <Box mb={2}>
            <Button
              variant="contained"
              color="primary"
              className={classes.buttonStyle}
              style={{ marginRight: 5 }}
              onClick={handleClose}
            >
              OK
            </Button>            
          </Box>
        </DialogActions>
      </Dialog>
    </div>
  );
}
